export const PAGE_TITLE = '服务详情'

export const recoveryCategoryId = '101121' // 产康的品类ID

// 购买 已售罄 暂不提供服务
// 立即预约 已售罄 暂不提供服务

// 获取个人信息用于分享图片时显示当前用户信息
export const URL_GET_USERINFO = 'https://user.cekid.com/user/GetUserInfo' //  skey: H594D0307B uid: 1300016546

// 获取本店其他商品
export const URL_GET_OTHERSERVICE =
  'https://sccapi.cekid.com/scc-api/api/spu/businessOtherService.do' // businessId=52740&spuId=954460

// 获取评论标签列表
export const URL_GET_comment_label_list =
  'https://soperationapi.czj100.com/soperation-api/comment/getCommentLabelList.do' //  category4Id=10111025&rid=954460

// 获取商品详情
export const URL_GET_CMMDTYDETAIL =
  'https://sccapi.cekid.com/scc-api/api/spu/queryCmmdtyDetailBySku.do' // skuId=142518

// 通过skuid获取商品详情
export const URL_GET_CMMDTYDETAIL_BY_SKU =
  'https://sccapi.cekid.com/scc-api/api/spu/queryCmmdtyDetailBySku.do'

// 获取评论列表
export const URL_GET_COMMENT =
  'https://soperationapi.czj100.com/soperation-api/comment/list2.do' // has_image=0&object_id=954460&orderBy=1&page=1&property=2&show_reply=1&show_user=1&size=2&skey=H594D0307B&type=9&uid=1300016546

// 获取spu 在 （！this.spuId && this.skuId && this.ruleType && this.ruleId ）的情况下通过 skuId和empId获取新的的spu
export const URL_GET_NEW_SPU_BY_SKU =
  'https://sccapi.cekid.com/scc-api/api/spu/queryFchildSpuRela.do' // empId=’‘&skuId=954460

// 获取门店 spuId: 954460 longitude: 118.88517 latitude: 32.01605 city: 320100
export const URL_QUERYSTOREBYSPUID =
  'https://scbapi.czj100.com/scb-api/appStore/queryStoreBySpuId.do'

// 获取退换货政策，头图是否显示视频等
export const URL_GET_HOME_SERVICE_CONFIG =
  'https://cms.cekid.com/publish/998/homeServiceConfig.json'

// 获取店铺销量 定制sku的店铺，店铺销量需要重新调接口获取
export const url_getSaleNum =
  'https://sccapi.cekid.com/scc-api/api/spu/queryAllSaleNumBySpuParentId.do'
